import CalibreRegular from '@static/fonts/Calibre-Regular.ttf';
import CanelaMedium from '@static/fonts/Canela-Medium.otf';
import CanelaLight from '@static/fonts/Canela-Light.otf';

const fonts = `
  @font-face {
    font-family: 'Calibre';
    font-style: normal;
    font-weight: normal;
    src: url('${CalibreRegular}') format('truetype');
  }

  @font-face {
    font-family: 'Canela';
    font-style: normal;
    font-weight: normal;
    src: url('${CanelaMedium}') format('opentype');
  }

  @font-face {
    font-family: 'Canela';
    font-style: normal;
    font-weight: 300;
    src: url('${CanelaLight}') format('opentype');
  }
`;

export default fonts;
